import classNames from 'classnames';
import * as React from 'react';
import { useBootstrapPrefix } from './ThemeProvider';
import { jsx as _jsx } from "react/jsx-runtime";
const CardImg = /*#__PURE__*/React.forwardRef(
// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(_ref, ref) => {
  let {
    bsPrefix,
    className,
    variant,
    as: Component = 'img',
    ...props
  } = _ref;
  const prefix = useBootstrapPrefix(bsPrefix, 'card-img');
  return /*#__PURE__*/_jsx(Component, {
    ref: ref,
    className: classNames(variant ? "".concat(prefix, "-").concat(variant) : prefix, className),
    ...props
  });
});
CardImg.displayName = 'CardImg';
export default CardImg;